<template>
  <div class="test-log" v-if="log && Array.isArray(log)">
    <h2>Log</h2>
    <div
      v-for="(loggedEvent, index) in logItems"
      :key="'event-' + index"
      class="test-log-item"
      :class="'type-' + loggedEvent.type"
      :style="computeStyle(loggedEvent)"
    >
      <div>
        {{ loggedEvent.timestamp | date }}
      </div>
      <div>
        {{ loggedEvent.event }}
        <div
          v-if="loggedEvent.note"
          class="event-note"
          :class="'event-note-' + loggedEvent.type"
          :style="computeStyle(loggedEvent)"
        >
          {{ loggedEvent.note }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    log: {
      type: Array,
      required: false
    }
  },
  methods: {
    computeStyle(loggedEvent) {
      if (loggedEvent.type === "status") {
        return {
          color: this.statusTypes[loggedEvent.event].color
        };
      }
      return {};
    }
  },
  computed: {
    ...mapState("TestsStore", ["statusTypes"]),
    logItems() {
      return [...this.log].reverse();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../styles/vars";

.test-log {
  display: flex;
  flex-direction: column;
  .test-log-item {
    display: flex;
    flex-direction: row;
    padding: @hh @h1 @hh @h3;
    position: relative;
    font-size: 0.9rem;
    &:not(:last-child):before {
      content: "";
      position: absolute;
      left: @h1 + @hh - 1px;
      top: @h2;
      width: 2px;
      bottom: -@h1;
      background-color: rgba(0, 0, 0, 0.1);
    }
    &:after {
      content: "";
      position: absolute;
      left: @h1;
      top: @h1;
      width: @h1;
      height: @h1;
      background-color: #fff;
      box-shadow: 0 0 0 2px #000;
      border-radius: 50%;
    }
    &.type-status {
      &:after {
        box-shadow: 0 0 0 2px currentColor;
      }
    }

    & > div {
      color: #000;
      &:first-child {
        flex: 0 30%;
      }
      &:last-child {
        flex: 0 70%;
      }
      .event-note {
        font-size: 0.9rem;
        font-style: italic;
        margin-top: @hh;
      }
    }
  }
}
</style>